<template>
  <Teleport :to="`#${navbarCtaId}`">
    <slot></slot>
  </Teleport>
</template>

<script lang="ts" setup>
import { navbarCtaId } from "./NavbarFixed.vue";
</script>
